module.exports = __webpack_public_path__ + "f56503fddb8d64eeca0028ea0942a2ba.png";